import { api } from "@/lib/api";

/**
 * セット品を切り替えたら何が起きるか（API の SetProductPreviewResponse）。
 *
 * 実行と同じ計画を通すので、見せた内容と結果が食い違わない。**見積から押しても
 * 案件から押しても同じ内訳**になる（紙の行は両方を指す 1 本で、切り替えは両方を
 * 同じ形に作り直す 1 つの操作のため）。
 */
export interface SetProductPreview {
  project_id: number;
  project_number: string;
  to_set_product: boolean;
  set_count: number | null;
  client_order_numbers: string[];
  current_item_count: number;
  next_item_count: number;
  /** false なら印だけが変わる（客先購番の行を持たない案件）。 */
  rebuilds_items: boolean;
  /** 作業実績と図面が残る行の客先購番。 */
  representative_po_number: string | null;
  /** 一緒に作り直す見積の見積番号。空なら見積は無い。 */
  quotation_numbers: string[];
  can_apply: boolean;
  /** 実行できない理由。そのまま画面に出す文言。 */
  blockers: string[];
}

export function previewProjectSetProduct(
  projectId: number,
  isSetProduct: boolean,
): Promise<SetProductPreview> {
  return api.get<SetProductPreview>(
    `/projects/${projectId}/set-product/preview?is_set_product=${isSetProduct}`,
  );
}

export function previewQuotationSetProduct(
  quotationId: number,
  isSetProduct: boolean,
): Promise<SetProductPreview> {
  return api.get<SetProductPreview>(
    `/quotations/${quotationId}/set-product/preview?is_set_product=${isSetProduct}`,
  );
}
